// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { EU, EUG, generateId } from '../../_common/api/utility';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Loading from '../../_common/Loading';
import Card from '../Card';
import LocationDropdown from '../LocationDropdown';
import WalletCard from '../WalletCard';
import WashClub from '../WashClub';

const Wallet = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
        setUserWallet
    } = useGlobalState();

    const [wallet, setWallet] = useState(null);
    const [shownWallet, setShownWallet] = useState(null);

    const { search } = useLocation();
    const location = new URLSearchParams(search)
    const [locFilter, setLocFilter] = useState(location.get('location') || active_user.forcedLocation || 0);

    useEffect(() => {
        setUserWallet()
            .then(res => {
                setWallet([...res])
            })
            .catch(ex => {
                setWallet(active_user.wallet || [])
            })
    }, [])

    useEffect(() => {
        if (!wallet) return;
        const items = parseInt(locFilter) !== 0 ? wallet.filter(e => e.locations.length === 0 || ~e.locations?.indexOf(parseInt(locFilter))) : wallet;
        let shown = {};
        items
            .sort((a, b) => new Date(b.purchasedDate) - new Date(a.purchasedDate))
            .forEach(e => {
                shown[e.label] ?
                    shown[e.label].push(e) :
                    shown[e.label] = [e];
            });

        if (shown.DollarDiscItem) {
            if (!shown.DollarDiscTrans) shown.DollarDiscTrans = [];
            shown.DollarDiscTrans = [...shown.DollarDiscTrans, ...shown.DollarDiscItem]
            delete shown.DollarDiscItem
        }

        setShownWallet(
            Object
                .entries(shown)
                .map(([key, val]) =>
                    <Card title={`${key} (${val.length})`} icon={EUG(key)} collapsible key={generateId()}>
                        {val.map(e => <WalletCard key={generateId()} {...e} />)}
                    </Card>
                )
        );
    }, [locFilter, wallet])

    if (!shownWallet) return <Loading />

    return (
        <>
            <LocationDropdown locFilter={locFilter} setLocFilter={setLocFilter} />
            {/* {wallet.find(e => e.isGift) ? <Firework /> : null} */}
            {
                active_user.washClub && (active_user.washClub.status === 'Active' || active_user.washClub.status === 'EndBillingPending') && (parseInt(locFilter) === 0 || active_user.washClub.locations.length === 0 || ~active_user.washClub.locations?.indexOf(parseInt(locFilter))) ?
                    <WashClub /> : null
            }
            {shownWallet}
        </>
    );
}

export default Wallet;


// const [cardNum, setCardNum] = useState('');
// <Forms
// inputs={{
//     cardNumber: cardNum,
// }}
// onSubmit={(e) =>
//     HamQuest.GetQuery(QuestRoute.giftCard.balance, {
//         cardNumber: e.cardNumber
//     })
//         .then(res => Modal.Show({
//             title: site_config.cardName + ' Balance',
//             body:
//                 <Col>
//                     <div>Status: {res.testMessage}</div>
//                     <div>Balance: {currency.format(res.balance ?? 0)}</div>
//                 </Col>
//         }))
// }
// submitbutton='Check'
// row
// >
// <Input
//     label='Check Balance'
//     name='cardNumber'
//     mask={Regex.mask.creditCard}
//     sanitize={Regex.match.notNumbers}
//     maxLength={19}
//     validate={Regex.test.creditCard}
//     required
// />
// </Forms>

// <MLTextReader
// update={setCardNum}
// pattern={/\d{16}/g}
// confirmation='Is this your card?'
// >Take a photo of your Gift Card</MLTextReader>